import { Component } from '@angular/core';

@Component({
    selector: 'app-loader',
    templateUrl: './loader.html',
    styleUrls: ['./loader.scss'],
    standalone: false
})
export class LoaderComponent {}
